import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let toastId = null;

const ToastMessage = ({ type, message }) => {
  const options = {
    className: 'b3rg-toast',
    theme: 'colored',
  };

  // Check if the toast is already active
  if (toastId !== null && toast.isActive(toastId)) {
    // If the toast is active, update it
    toast.update(toastId, {
      type: toast[type] ? type : 'default',
      render: message,
    });
  } else if (toast[type]) {
    toastId = toast[type](message, options);
  } else {
    toastId = toast(message, options);
  }
  return <ToastContainer />;
};

export default ToastMessage;
